export const environment = {
  production: true,
  profiles: ["production"],
  file: {
    allowedExtensions: ["txt", "jpg", "gif", "png", "jpeg", "doc", "pdf", "xls", "xlsx", "odt", "ods", "docx", "bdoc", "asice", "cdoc", "heic"],
    extensionToMime: {
      "txt": "plain",
      "jpg": "jpeg",
      "gif": "gif",
      "png": "png",
      "jpeg": "jpeg",
      "doc": "msword",
      "pdf": "pdf",
      "xls": "vnd.ms-excel",
      "xlsx": "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "odt": "vnd.oasis.opendocument.text",
      "ods": "vnd.oasis.opendocument.spreadsheet",
      "docx": "vnd.openxmlformats-officedocument.wordprocessingml.document",
      "bdoc": "asice",
      "asice": "vnd.etsi.asic-e+zip",
      "cdoc": "x-cdoc",
      "heic": "heic",
    },
    maxFileSize: 10485760, // 10Mb
  },
  logLevel: ["warn", "error"],
  cookiesExpirationTime: 584,
  serviceWorker: true,
  backend: {
    baseUrl: "",
    contextPath: "/egp_core",
    fileDownload: "/fileDownload?fileId=",
  },
  desktopRedirect: {
    isRedirect: false,
    isBaseUrl: true,
    url: "/patient/",
  },
  session: {
    messageFetchFrequency: 60,
    sessionLength: 14400,
    idleLength: 300,
  },
  languages: ["et", "en", "ru"],
  googleLogin: {
    enabled: false,
    // live clientId
    clientId: "713969285975-1e5h71fst15r8bl28t598rp28e84oi70.apps.googleusercontent.com",
  },
  biometricsLogin: {
    enabled: false,
  },
  thirdPartyLogin:{
    cookieExpirationTime: 584,
    domainName: ".eperearstikeskus.ee",
  },
  emails: {
    customerService: btoa("tugi@eperearstikeskus.ee"),
    ttoCustomerService: btoa("ttotugi@eperearstikeskus.ee"),
  },
  videoMeeting: {
    domain: "video.eperearstikeskus.ee",
  },
  webPages: {
    medreLink: "https://medre.tehik.ee/search/gp-lists",
  },
  consentService: {
    insuranceDeclarationId: "EPAK-KIRST-KINDLUSTATUS",
    prescriptionDeclarationId: "EPAK-RETS-RETSEPTIDE_INFO_PATSIENT",
    takeBackConsentUrl: "https://www.eesti.ee/nousolek/et/consent",
  },
  premium: {
    institutionName: "Etohter"
  },
  partnership: {
    apotheka: {
      event: "apotheka",
      source: "app",
    },
    lifery: {
      event: "lifery",
    }
  },
};
